{
	"backLinkTitle": "Wróć do: Zarządzaj deklaracjami",
	"invoicedQuantity": "Ilość zafakturowana",
	"remainingForDeclarationCreation": "Pozostało do utworzenia deklaracji",
	"nonTransferableAmount": "Kwota niepodlegająca alokacji",
	"btnCreateDeclaration": "+ Utwórz deklarację",
	"errorMessage": "Nie udało się wczytać szczegółów materiału"
}
